import React from "react";
import PlanPriceInfoComp from "../../../PlanPriceInfoComp/PlanPriceInfoComp";
import type { PlanPriceInfoCompProps } from "../../../PlanPriceInfoComp/PlanPriceInfoComp";
import { useTravellerDetailsContext } from "../../contexts/TravellerDetailsV2Context";

export const PlanInfoSection = ({
  planInfo,
  planType,
  sumInsured,
  amountToPay,
  cancellationInfo,
}: {
  planInfo?: { name?: unknown; icon?: string };
  planType?: unknown;
  sumInsured?: unknown;
  amountToPay?: unknown;
  cancellationInfo?: PlanPriceInfoCompProps["cancellationInfo"];
}) => {
  const { onPlanEdit } = useTravellerDetailsContext();
  const icon =
    typeof planInfo?.icon === "string" ? planInfo.icon.trim() : "";

  const payload: PlanPriceInfoCompProps = {
    planType: planType as PlanPriceInfoCompProps["planType"],
    planInfo: {
      name: (planInfo?.name ?? { text: { value: "" } }) as PlanPriceInfoCompProps["planInfo"]["name"],
      icon,
    },
    sumInsured: sumInsured as PlanPriceInfoCompProps["sumInsured"],
    amountToPay: amountToPay as PlanPriceInfoCompProps["amountToPay"],
    cancellationInfo,
    onEditClick: onPlanEdit,
  };

  return (
    <div style={{ padding: "0 16px" }}>
      <PlanPriceInfoComp {...payload} />
    </div>
  );
};
